import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconArrowLeftBold';
/** Renders an SVG icon. */
const SvgArrowLeftBold = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M30 16a2 2 0 0 1-2 2H9.212l6.126 5.513a2 2 0 0 1-2.676 2.974l-10-9a2 2 0 0 1 0-2.974l10-9a2 2 0 1 1 2.676 2.974L9.212 14H28a2 2 0 0 1 2 2"
      />
    </svg>
  );
};
SvgArrowLeftBold.displayName = displayName;
export default SvgArrowLeftBold;
